import React, { FC, useState } from 'react';
import { Tabs, Tab } from '@mercell/tabs-react';
import OktaAuthWrapper from '../../authorization/OktaAuthWrapper';
import NoAccessPage from '../NotFound/NoAccessPage';
import { useAppSelector } from '../../redux/hooks';
import useFetchUserRights from '../../hooks/useFetchUserRights';
import { UserRole } from '../../types/generated/userRightsResult';
import CloudWatchLogsTab from './CloudWatchLogsTab';
import ActivityLogTab from './ActivityLogTab';
import { ProgressSpinner } from '../../components/ProgressSpinner';
import { useTranslation } from 'react-i18next';

const cloudWatchTab = 'cloudwatch-logs';
const activityLogTab = 'activity-log';

const LogsExplorerPage: FC = () => {
    const [activeTab, setActiveTab] = useState<string>(cloudWatchTab);
    const reduxUserRights = useAppSelector((state) => state.store.userRights);
    const { UserRights, isLoadingUserRights } = useFetchUserRights();
    const { t } = useTranslation(['form-content.logs']);

    const isSuperAdmin = UserRights?.userRole === UserRole.SuperAdmin;

    if (reduxUserRights?.logsExplorerEnabled === false) {
        return <NoAccessPage />;
    }

    let explorerContent: React.ReactNode;
    if (isLoadingUserRights) {
        explorerContent = (
            <div className="flex justify-center py-12">
                <ProgressSpinner />
            </div>
        );
    } else if (isSuperAdmin) {
        explorerContent = (
            <Tabs activeKey={activeTab} onTabChange={setActiveTab}>
                <Tab
                    tabKey={cloudWatchTab}
                    title={t('form-content.logs:logs-explorer.tabCloudWatchLogs')}
                >
                    <CloudWatchLogsTab />
                </Tab>
                <Tab
                    tabKey={activityLogTab}
                    title={t('form-content.logs:logs-explorer.tabActivityLog')}
                >
                    <ActivityLogTab />
                </Tab>
            </Tabs>
        );
    } else {
        explorerContent = <CloudWatchLogsTab />;
    }

    return (
        <OktaAuthWrapper>
            <div className="col-span-full xl:justify-self-center xl:min-w-[1200px] max-w-[1400px] whitespace-normal">
                <h2 className="mb-6">
                    {t('form-content.logs:logs-explorer.pageTitle')}
                </h2>
                {explorerContent}
            </div>
        </OktaAuthWrapper>
    );
};

export default LogsExplorerPage;
